import { usePage } from '@inertiajs/react';
import type { Brand, BrandFeature, SharedData } from '@/types';

export function useBrand(): Brand {
    return usePage<SharedData>().props.brand;
}

export function useFeature(feature: BrandFeature): boolean {
    return useBrand().features.includes(feature);
}

export function useCardVariant(): 'photo_first' | 'rich' | 'magazine' {
    return useBrand().card_variant ?? 'rich';
}

/**
 * Returns a formatter that uses Intl.NumberFormat with the brand's locale
 * and currency code. Handles symbol, placement, and separators automatically.
 *
 * Usage: const formatPrice = useFormatPrice();
 *        formatPrice(91) → "€91" / "$91" / "91 €" depending on locale
 */
export function useFormatPrice(): (amount: number | string) => string {
    const { currency, default_locale } = useBrand();
    const formatter = new Intl.NumberFormat(default_locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
    });
    return (amount) => formatter.format(Number(amount));
}
